import { getDecodedJWT } from '@/util/jwt_helper'

export const isSupportUser = (jwt: string | undefined): boolean => {
  if (!jwt) return false
  const decodedJwt = getDecodedJWT(jwt)
  if (!decodedJwt) return false
  return !!(decodedJwt?.supportAgentId || decodedJwt?.appMeta?.supportAgentId)
}

/**
 * Get custom object labels from the store
 * @param store - Vuex store instance
 * @returns Object containing singular and plural labels for contact and business objects
 */
export const getCustomObjectLabels = (store: any) => {
  return {
    contact: {
      singular: store.getters['customObjectsStore/getObjectSingularLabelByKey']('contact'),
      plural: store.getters['customObjectsStore/getObjectPluralLabelByKey']('contact'),
    },
    business: {
      singular: store.getters['customObjectsStore/getObjectSingularLabelByKey']('business'),
      plural: store.getters['customObjectsStore/getObjectPluralLabelByKey']('business'),
    }
  }
} 